import { Blocks, Brush, Hand, BookOpen, Activity, MessagesSquare } from "lucide-react";
import { DEV_CARDS } from "@/data/content";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { imgProps } from "@/lib/img";

const ICONS = { Blocks, Brush, Hand, BookOpen, Activity, MessagesSquare };

export default function Development() {
  return (
    <section id="rozvytok" className="relative py-16 sm:py-24 px-4" data-testid="development-section">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <Eyebrow number="05" text="Розвиток" />
          <h2 className="font-display text-center text-3xl sm:text-4xl lg:text-5xl font-bold text-white" data-testid="development-title">
            МИ РОЗВИВАЄМО <span className="text-gold-gradient">НЕ ЛИШЕ ЗНАННЯ</span>
          </h2>
        </Reveal>

        <div className="mt-10 sm:mt-14 grid grid-cols-2 gap-3 sm:flex sm:flex-col sm:gap-6">
          {[[0, 1, 2], [3, 4, 5]].map((row, ri) => (
            <div key={ri} className="contents sm:flex sm:flex-row sm:gap-6">
              {row.map((i) => {
                const c = DEV_CARDS[i];
                const Icon = ICONS[c.icon];
                return (
                  <Reveal key={c.title} delay={i * 0.08} className={`dev-flex dev-order-${i}`} style={{ "--r": c.ratio }}>
                    <div
                      className="group relative rounded-2xl sm:rounded-3xl overflow-hidden border border-amber-400/15 bg-[#0a211a] hover:border-amber-300/45 hover:-translate-y-2 hover:shadow-[0_20px_50px_rgba(230,184,92,0.15)] transition-all duration-500"
                      data-testid={`dev-card-${i}`}
                    >
                      <div className="overflow-hidden aspect-square sm:aspect-auto bg-[#071a13] flex items-center justify-center sm:block">
                        <img
                          {...imgProps(c.img, "(max-width: 640px) 44vw, 33vw")}
                          alt={c.title}
                          className="w-full h-full object-contain sm:h-auto sm:object-cover block transition-transform duration-700 group-hover:scale-110"
                        />
                      </div>
                      <div className="p-3 sm:p-5 flex items-center gap-2.5 sm:gap-3">
                        <span className="w-8 h-8 sm:w-9 sm:h-9 rounded-xl bg-amber-300/15 border border-amber-300/30 flex items-center justify-center shrink-0">
                          <Icon className="w-4 h-4 text-amber-300" />
                        </span>
                        <span className="font-semibold text-white text-xs sm:text-lg leading-snug">{c.title}</span>
                      </div>
                    </div>
                  </Reveal>
                );
              })}
            </div>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-12 text-center">
          <p className="font-display italic text-xl sm:text-2xl text-amber-100/90" data-testid="development-final-phrase">
            ✦ Кожен день — новий крок у розвитку ✦
          </p>
        </Reveal>
      </div>
    </section>
  );
}
